var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'active-tab-underline': _vm.isCurrentActiveTab, 'tab-item': true }},[_c('button',{staticClass:"tab-title",attrs:{"aria-label":'Account Navigation'},on:{"click":function($event){return _vm.routeToView()},"keydown":_vm.handleEscape}},[_vm._v("\n    "+_vm._s(_vm.tab.title)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }